var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _circle4, _path6, _path7, _path8, _path9, _path10, _polygon, _path11, _polygon2, _path12, _circle5, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 500.39724,
    height: 517.98652,
    viewBox: "0 0 883.39724 517.98652",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1025.19862,628.55459H384.36012a16.51867,16.51867,0,0,1-16.5-16.5V216.90078A12.10185,12.10185,0,0,1,379.948,204.8124H1029.4015a12.31112,12.31112,0,0,1,12.29712,12.29737V612.05459A16.51868,16.51868,0,0,1,1025.19862,628.55459Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.82133,605.18776H404.57658c-8.755,0-15.87756-6.66992-15.87756-14.86817v-344.105c0-6.08008,5.27795-11.02685,11.76562-11.02685h605.27368c6.59522,0,11.9607,5.02832,11.9607,11.20849V590.31959C1017.699,598.51784,1010.57622,605.18776,1001.82133,605.18776Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.46888,215.95693H367.62855v-8.40039a16.57376,16.57376,0,0,1,16.56006-16.5498h640.72021a16.57368,16.57368,0,0,1,16.56006,16.5498Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 239.42253,
    cy: 12.5,
    r: 4.28342,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.68134,
    cy: 12.5,
    r: 4.28342,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.94014,
    cy: 12.5,
    r: 4.28342,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M499.90173,541.18719H351.06323a17.5199,17.5199,0,0,1-17.5-17.5V347.53338A13.10308,13.10308,0,0,1,346.65112,334.445H504.10461a13.31242,13.31242,0,0,1,13.29712,13.29737V523.68719A17.51982,17.51982,0,0,1,499.90173,541.18719Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M499.90173,541.18719H351.06323a17.5199,17.5199,0,0,1-17.5-17.5V347.53338A13.10308,13.10308,0,0,1,346.65112,334.445H504.10461a13.31242,13.31242,0,0,1,13.29712,13.29737V523.68719A17.51982,17.51982,0,0,1,499.90173,541.18719ZM346.65112,336.445a11.10062,11.10062,0,0,0-11.08789,11.08838V523.68719a15.51744,15.51744,0,0,0,15.5,15.5h148.8385a15.51752,15.51752,0,0,0,15.5-15.5V347.74237A11.31,11.31,0,0,0,504.10461,336.445Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.1811,
    cy: 225.33418,
    r: 30.72361,
    fill: "#ff6010"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M474.703,490.01488H376.262v-.31351a34.21088,34.21088,0,0,1,34.17218-34.17217h30.09659A34.21089,34.21089,0,0,1,474.703,489.70137Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#ff6010"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M339.65689,474.39632a10.05577,10.05577,0,0,1-14.16116-6.10061l-35.70082-1.55895,10.8896-15.04162,32.23261,3.78644a10.11028,10.11028,0,0,1,6.73977,18.91474Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5384,460.14316l-19.63257-37.811a31.3182,31.3182,0,0,1,2.564-33.03857c.69946-.9336,1.44165-1.8418,2.20605-2.69874A30.39792,30.39792,0,0,1,250.75324,376.504a31.40231,31.40231,0,0,1,24.11206,14.08106l9.42823,14.252c.96508.86182,13.94287,12.8374,9.11523,28.42041l-.83008,14.94287a4.52344,4.52344,0,0,1-3.4751,4.1333l-43.553,10.11866a4.49435,4.49435,0,0,1-5.01221-2.30909Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#ff6010"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.76908,531.89964a10.05577,10.05577,0,0,1,1.56841-15.33935L219.108,482.0379l17.61677,5.87226,6.06366,31.88276a10.11027,10.11027,0,0,1-16.01932,12.10672Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M222.442,515.56553a4.4626,4.4626,0,0,1-2.46118-3.31592l-6.07739-58.96a50.33629,50.33629,0,0,1-.35889-14.48975l7.28516-44.11865a10.06808,10.06808,0,0,1,10.7334-8.86182h0a10.08789,10.08789,0,0,1,9.301,11.23975L234.91633,447.669l6.81128,59.69141a4.47622,4.47622,0,0,1-2.34937,4.47852l-12.88452,3.67968a4.44955,4.44955,0,0,1-4.05176.04688Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#ff6010"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "161.751 504.359 173.796 502.075 170.717 454.528 152.94 457.9 161.751 504.359",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316.23434,692.016l23.721-4.49868.001-.00018a15.386,15.386,0,0,1,17.98342,12.25056l.09314.49125-38.83826,7.36553Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "55.162 504.734 67.422 504.733 73.254 457.445 55.16 457.446 55.162 504.734",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.33626,691.73774l24.1438-.001h.001A15.38605,15.38605,0,0,1,249.86751,707.123v.5l-39.53052.00146Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.03279,
    cy: 150.33062,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.44489,676.73545a4.52272,4.52272,0,0,1-1.19507-3.4043l16.71753-151.751c-.14379-1.4209-2.4143-27.1875,16.009-60.15625l.1018-.18213,49.36792-13.68994,5.45874,23.02636,36.58277,200.21094a4.486,4.486,0,0,1-3.80542,4.94336l-12.7334,1.91016a4.50191,4.50191,0,0,1-4.98608-3.18457L269.8509,539.42881a1.50036,1.50036,0,0,0-2.87769-.01367L231.60505,674.92393a4.52284,4.52284,0,0,1-4.32153,3.24414H214.73689A4.51522,4.51522,0,0,1,211.44489,676.73545Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M315.78278,471.6627l-53.19238-9.12061A17.40944,17.40944,0,0,1,248.42829,448.92l-11.10693-52.4585a14.30958,14.30958,0,0,1,13.41284-17.26171h0a14.38357,14.38357,0,0,1,14.79614,12.604l5.574,46.7583,46.9248,12.19238a4.49882,4.49882,0,0,1,3.03418,4.26514l-.02,12.21924a4.49624,4.49624,0,0,1-5.2605,4.42383Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#ff6010"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M270.22711,335.63581c3.90962-.80832,7.711-3.40948,8.7554-7.26275.91236-3.36611-.43741-6.99535-2.55031-9.77a19.73745,19.73745,0,0,0-23.64558-5.57725c.37737-1.98479-1.11552-3.94291-2.95263-4.78364a13.75273,13.75273,0,0,0-5.95486-.79972c-6.38994.08932-13.193.30274-18.47651,3.89776-4.21305,2.86667-6.88794,7.58032-8.27374,12.48409s-1.61217,10.04939-1.8301,15.14056c-.38195,8.92283,3.11413,27.70321,3.11413,27.70321s12.36326,3.39891,17.7795,4.97366c5.82024,1.69221,15.64048,3.38443,21.46072,5.07664,1.48969.43312,3.4846.67631,4.23322-.68249.59765-1.08479-.09354-2.4061-.78855-3.43124-3.06038-4.514-6.56636-8.77139-8.92068-13.69069s-3.456-10.76465-1.43463-15.82988S266.3175,336.44412,270.22711,335.63581Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M655.86638,508.46168h319.8385a16,16,0,0,0,16-16V347.91383a16,16,0,0,0-16-16H655.86638a16,16,0,0,0-16,16V492.46168A16,16,0,0,0,655.86638,508.46168Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M940.78569,428.18776h-255a8,8,0,1,1,0-16h255a8,8,0,0,1,0,16Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M940.78569,462.18776h-255a8,8,0,1,1,0-16h255a8,8,0,0,1,0,16Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M895.78569,394.18776h-210a8,8,0,1,1,0-16h210a8,8,0,0,1,0,16Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M398.30138,708.99326h-239a1,1,0,0,1,0-2h239a1,1,0,1,1,0,2Z",
    transform: "translate(-158.30138 -191.00674)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateUser);
export default __webpack_public_path__ + "static/media/createUser.3840074665583c4b2838b3f8312e0983.svg";
export { ForwardRef as ReactComponent };